import { zSchema } from "../../../schema-validation";

export const companyTriggerMicrodepositSchema = zSchema.object({
  odo_user_id: zSchema.string(),
  partner_business_name: zSchema.string().optional(),
  payment_destination_id: zSchema.string().optional(),
});
